import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/forgot-password")({
  head: () => ({
    meta: [
      { title: "Passwort zurücksetzen, OM Selected" },
      { name: "description", content: "Setze dein Passwort für OM Selected zurück." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (error) throw error;
      setSent(true);
    } catch (err: any) {
      setError(err.message ?? t("auth.sendError"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto max-w-md px-5 md:px-10 py-20">
      <div className="eyebrow text-muted-foreground">{t("auth.editorial")}</div>
      <h1 className="serif text-4xl md:text-5xl mt-4">{t("auth.forgotTitle")}</h1>
      {sent ? (
        <p className="mt-10 text-muted-foreground">
          {t("auth.forgotSent")}
        </p>
      ) : (
        <form onSubmit={onSubmit} className="mt-10 space-y-6">
          <p className="text-sm text-muted-foreground">
            {t("auth.forgotIntro")}
          </p>
          <label className="block">
            <div className="eyebrow text-muted-foreground mb-2">{t("common.email")}</div>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border-b border-foreground bg-transparent py-2 outline-none"
            />
          </label>
          {error && <div className="text-sm text-destructive">{error}</div>}
          <button
            type="submit"
            disabled={busy}
            className="eyebrow border border-foreground px-6 py-3 hover:bg-foreground hover:text-background transition-colors disabled:opacity-50"
          >
            {busy ? t("auth.sending") : t("auth.sendLink")}
          </button>
        </form>
      )}
      <Link to="/login" className="eyebrow inline-block mt-12 border-b border-foreground pb-1">
        {t("common.backToLogin")}
      </Link>
    </div>
  );
}